'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBorderRadius = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _Length = require('../Length');

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];

var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
  return SIDES.map(function (side) {
    var value = style.getPropertyValue('border-' + side + '-radius');

    var _value$split$map = value.split(' ').map(_Length2.default.create),
        _value$split$map2 = _slicedToArray(_value$split$map, 2),
        horizontal = _value$split$map2[0],
        vertical = _value$split$map2[1];

    return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
  });
};